import './feature-tabs.css';

export default () => {
  class featureTabs extends HTMLElement {
    constructor() {
      super();
      this.initializeTabs = this.initializeTabs.bind(this);
    }

    connectedCallback() {
      this.initializeTabs();
      window.addEventListener('resize', this.initializeTabs);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.initializeTabs);
    }

    activateColumn(column) {
      const columnClassAnimation = column.querySelector('.js-section--animation');
    
      this.contents.forEach(cont => {
        cont.classList.add("hide");
        
        if (!column.classList.contains('active')) {
          cont.classList.remove("show", "fade");
        }
      });
  
      this.columns.forEach(item => {
        item.classList.remove("active");
        item.setAttribute('aria-selected', 'false');
      });
  
      column.classList.add("active");
      column.setAttribute('aria-selected', 'true');
      columnClassAnimation.classList.remove("hide");
      columnClassAnimation.classList.add("show");
  
      if (!column.classList.contains('fade')) {    
        setTimeout(() => {
          columnClassAnimation.classList.add("fade");
        }, 100);
      }
    }
  
    initializeTabs() {
      this.columns = this.querySelectorAll('.feature-tabs__column');
      this.contents = this.querySelectorAll('.js-section--animation');
      this.isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;

      const eventType = this.isMobile ? 'click' : 'mouseenter';
    
      this.columns.forEach(column => {
        column.addEventListener(eventType, () => {
          this.activateColumn(column);
        });
      });
    }
  }

  const init = () => {
    if (!customElements.get("feature-tabs")) {
      customElements.define("feature-tabs", featureTabs);
    }
  };
  
  init();
}